/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { FormUpdatePayload } from '../../redux';
import { DBSchema, OpenDBCallbacks } from "idb";
import { DairyFARMDB } from "../store";

export const LIVE_EVAL_PATCHES_STORE = "live_eval_patches" as "live_eval_patches";
export const PENDING_EVAL_PATCHES_STORE = "pending_eval_patches" as "pending_eval_patches";

export type PatchLog = FormUpdatePayload[];

export type PatchSchema = {
  /**
   * Patches in the live eval patch store will become stuck if any patches fail to get applied on the server due to schema conflicts.
   * Once these patches are stuck they need to be synced to the server behind the scenes. The evaluation on the server won't be updated,
   * but the data won't be lost. Once a live eval patch is synced this way, it is marked as synced so as to not be sent again.
   */
  synced?: boolean;
  evalId: string;
  patches: PatchLog;
  uuid: string | null;
};

export type QueuedPatchSchema = {
  evalId: string;
  patches: PatchLog;
  uuid: string;
  locked?: boolean;
};

export interface PatchStore extends DBSchema {
  [LIVE_EVAL_PATCHES_STORE]: {
    key: string;
    value: PatchSchema;
  };
  [PENDING_EVAL_PATCHES_STORE]: {
    key: string;
    value: QueuedPatchSchema;
  }
}

export const patchStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(LIVE_EVAL_PATCHES_STORE)) {
      db.createObjectStore(LIVE_EVAL_PATCHES_STORE, {
        keyPath: "evalId",
      });
    }
    
    if (!db.objectStoreNames.contains(PENDING_EVAL_PATCHES_STORE)) {
      db.createObjectStore(PENDING_EVAL_PATCHES_STORE, {
        keyPath: "evalId",
      });
    }
  },
};


// Pending Upload Patch Store
